<div class="container" *ngIf="loanAppPageSvc.selectedLoanApplication$ | async as app">
    <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>
    <!-- Mobile View -->
    <div class="container mobile-tasks-view d-block d-md-none">
        <mat-card-subtitle>
            <h1>Tasks</h1>
            <div style="clear:both;"></div>

            <!-- <ng-container *ngIf="isClient">
                <div class="col-8" style="display: flex;">
                    <h6 class="float-left">{{app?.loanInfo?.loanNumber ?? 'Pending'}}</h6>
                    <div *ngIf="app?.loanInfo?.subjectPropertyAddress?.street" class="float-left dot-hyphen">&nbsp;
                    </div>
                    <h6 class="float-left">{{app?.loanInfo?.subjectPropertyAddress?.street}}</h6>
                </div>
                <span *ngIf="firstBorrower$ | async as b1" (click)="onReturnToClientHome(b1)"><a>{{b1.firstName}}
                        {{b1.lastName}}</a></span>
                <span *ngIf="secondBorrower$ | async as b2" (click)="onReturnToClientHome(b2)"> | <a>{{b2.firstName}}
                        {{b2.lastName}}</a></span>
                <div class="Vert-15"></div>
            </ng-container> -->

            <div *ngIf="taskStatusList$ | async as taskStatusList" class="loan-app-task">
                <ng-container *ngFor="let tls of taskStatusList">
                    <div *ngIf="tls.value > 0" class="float-left opaque rect" [ngClass]="tls.name"
                        style="cursor: pointer;" (click)="filterStatuses(tls.name)">
                        <span>{{tls.value}} {{tls.name === 'Rejected' ? 'Re-requested' : tls.name}}</span>
                    </div>
                </ng-container>
            </div>
        </mat-card-subtitle>
        <ng-container *ngIf="isInternalUser && !(lgvUserSvc.IsPreLicensedAgent$ | async)">
            <button type="button" class="btn btn-secondary" style="width: 100%;font-size:20px;" (click)="onAddTask()">
                New Task&nbsp;
                <fa-icon icon="plus-circle" title="New Task"></fa-icon>
            </button>
        </ng-container>
        <ng-template #noTasks>
            There are no tasks for this Loan Application
        </ng-template>

        <div class="Vert-15" style="border-bottom: 1px solid #ccc;"></div>
        <div class="Vert-15"></div>

        <div *ngIf="tasks$ | async as tasks" class="task-list">
            <div class="task-item" *ngFor="let t of tasks">
                <div class="task-summary" (click)="toggleDetail(t)">
                    <div class="status-row loan-app-task">
                        <div class="float-left circle" [ngClass]="t.status.name" style="padding-right:15px;"></div>
                        <div class="tooltipcell">{{t.taskStatusTimestamp | date: 'MM/dd/yy'}}
                            <span class="tooltiptext"
                                [innerHTML]="getTootltipText(t.taskStatusTimestamp, t.status.name)"></span>
                        </div>

                        <ng-container *ngIf="isClient">
                            <div class="grid-context-menu">
                                <div class="action-button" [title]="getTooltip(t)" 
                                    [class.file-disabled]="!(isUploadAllowed(t) && isOpenAllowed(t))"
                                    [class.file-enabled]="isUploadAllowed(t) || isOpenAllowed(t)">
                                    <fa-icon [ngStyle]="{'color': getColor(t)}" [icon]="getIcon(t)"></fa-icon>
                                </div>
                            </div>
                        </ng-container>
                        <ng-conteiner *ngIf="isInternalUser">
                            <div class="grid-context-menu">
                                <div class="grid-context-menu-link" [matMenuTriggerFor]="taskMenu"
                                    [title]="getTooltip(t)"
                                    *ngIf="isEditAllowed(t) || isOpenAllowed(t) || isDeleteAllowed(t)"
                                    style="cursor: pointer;">
                                    <fa-icon class="ellipsis" icon="bars"></fa-icon>
                                </div>
                                <mat-menu #taskMenu="matMenu">
                                    <div class="rowContextPopupMenu">
                                        <button mat-menu-item title="Open" (click)="onOpenTaskItem(t)"
                                            *ngIf="isOpenAllowed(t)">
                                            <fa-icon icon="file-lines"></fa-icon>Open
                                        </button>
                                        <button mat-menu-item title="Upload" (click)="onUploadDocument(t)"
                                            *ngIf="isUploadAllowed(t)">
                                            <fa-icon icon="file-arrow-up"></fa-icon>Upload
                                        </button>
                                        <button mat-menu-item title="Upload" (click)="onDuplicateTask(t)"
                                            *ngIf="isDuplicateAllowed(t)">
                                            <fa-icon icon="file-arrow-up"></fa-icon>Duplicate
                                        </button>
                                        <button mat-menu-item title="Edit" (click)="onEditTask(t)"
                                            *ngIf="isEditAllowed(t)">
                                            <fa-icon icon="edit"></fa-icon>Edit
                                        </button>
                                        <button mat-menu-item title="Delete" (click)="onConfirmDeleteTask(t)"
                                            *ngIf="isDeleteAllowed(t)">
                                            <fa-icon icon="trash"></fa-icon>Delete
                                        </button>
                                    </div>
                                </mat-menu>
                            </div>
                        </ng-conteiner>

                    </div>
                    <div class="task-details">
                        <div class="task-detail" style="padding-bottom: 5px;"><b>{{t.name}}</b></div>
                        <div class="task-detail" *ngIf="!t.description || t.name !== t.description">{{t.description}}
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="isInternalUser">
                    <div class="task-extra-details" *ngIf="t.expanded">
                        <div><strong>Type:</strong> {{t.type.name}}</div>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="Vert-10"></div>
        <lgv-file-upload-box [uploadBoxCSS]="uploadBoxCSS" [showInternalUserCheck]="false"
            [customText]="'Choose file, or upload photo'" (dragOver)="onDragOver($event)"
            (dropSuccess)="onDropSuccess($event)" (dragLeave)="onDragLeave($event)"
            (clickEvent)="onClickEvent($event)"></lgv-file-upload-box>
    </div>

    <!-- Desktop View -->
    <div class="container-fluid d-none d-md-block d-lg-block d-xl-block d-xxl-block">
        <mat-card-subtitle>
            <div class="row" style="align-items:center;justify-content:space-between;">
                <div class="col-2" style="width: auto;">
                    <h1 style="margin: 0px;">Tasks</h1>
                </div>
                <div *ngIf="taskStatusList$ | async as taskStatusList" class="loan-app-task col-7"
                    style="align-self: center; padding-left: 10px;">
                    <ng-container *ngFor="let tls of taskStatusList">
                        <div *ngIf="tls.value > 0 && isClient" class="float-left opaque rect" [ngClass]="tls.name"
                            style="cursor: pointer;" (click)="filterStatuses(tls.name)">
                            <span>{{tls.value}} {{tls.name === 'Rejected' ? 'Re-requested' : tls.name}}</span>
                        </div>
                        <div *ngIf="tls.value > 0 && isInternalUser" class="float-left opaque rect tooltipcell"
                            [ngClass]="tls.name" style="cursor: pointer;" (click)="filterStatuses(tls.name)">
                            {{tls.value}} {{tls.name === 'Rejected' ? 'Re-requested' : tls.name}}
                            <span class="tooltiptext" [innerHTML]="getStatusTootltipText(tls.value, tls.name)"></span>
                        </div>
                    </ng-container>
                </div>
                <div class="col-3 d-flex justify-content-end">
                    <button *ngIf="isInternalUser && !(lgvUserSvc.IsPreLicensedAgent$ | async)"
                        class="btn btn-primary skinny" (click)="onAddTask()">
                        <fa-icon icon="plus" title="New Task"></fa-icon> Add Task
                    </button>
                </div>
            </div>

            <div class="Vert-10"></div>
        </mat-card-subtitle>


        <ng-template #noTasks>
            There are no tasks for this Loan Application
        </ng-template>

        <ng-container *ngIf="tasks$ | async as tasks; else noTasks">
            <table class='table' *ngIf="tasks.length > 0; else noTasks">
                <thead>
                    <tr>
                        <th><lgv-grid-header [HeaderText]="'Status'" [SortField]="'status'"
                                [Mgr]="GridMgr"></lgv-grid-header></th>
                        <th><lgv-grid-header [HeaderText]="'Name'" [SortField]="'name'"
                                [Mgr]="GridMgr"></lgv-grid-header></th>
                        <th><lgv-grid-header [HeaderText]="'Type'" [SortField]="'type'"
                                [Mgr]="GridMgr"></lgv-grid-header></th>
                        <th><lgv-grid-header [HeaderText]="'Description'" [SortField]="'description'"
                                [Mgr]="GridMgr"></lgv-grid-header></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let t of tasks">
                        <tr *ngIf="isClient" (click)="handleClick(t)" style="cursor: pointer;">
                            <td style="min-width:150px;" class="loan-app-task">
                                <div style="display: flex;">
                                    <div class="float-left circle" [ngClass]="t.status.name">&nbsp;</div>
                                    <div class="float-left">
                                        <div class="tooltipcell">{{t.taskStatusTimestamp | date: 'MM/dd/yy'}}
                                            <span class="tooltiptext"
                                                [innerHTML]="getTootltipText(t.taskStatusTimestamp, t.status.name)"></span>
                                        </div>
                                    </div>
                                    <div style="clear:both"></div>
                                </div>
                            </td>
                            <td>
                                {{t.name}}
                                <span style="font-size: 12px; font-weight: bold;"
                                    *ngIf="t?.document?.name && t.status.name!= 'Rejected' && !(lgvUserSvc.IsPreLicensedAgent$ | async)"><br>
                                    <a (click)="openTaskDocument(t)">{{t?.document?.name ?? ""}}</a></span>
                                <span style="font-size: 12px; font-weight: bold; color: #FF3A1F;"
                                    *ngIf="t.status.name== 'Rejected' && !(lgvUserSvc.IsPreLicensedAgent$ | async)"><br>{{t?.rejectionReason?.name
                                    ?? ""}}</span>
                            </td>
                            <td style="min-width:75px;">{{t.type.name}}</td>
                            <td><span *ngIf="t.status.name== 'Rejected'"
                                    style="color: #FF3A1F;">{{t?.rejectionReasonNote ?? ""}}
                                </span>{{t.description}}</td>
                            <td *ngIf="isClient" [title]="getTooltip(t)"
                                [class.file-disabled]="!(isUploadAllowed(t) && isOpenAllowed(t))"
                                [class.file-enabled]="isUploadAllowed(t) || isOpenAllowed(t)">
                                <fa-icon [ngStyle]="{'color': getColor(t)}" [icon]="getIcon(t)"></fa-icon>
                            </td>
                        </tr>
                        <tr *ngIf="isInternalUser">
                            <td style="min-width:150px;" class="loan-app-task">
                                <div style="display: flex;">
                                    <div class="float-left circle" [ngClass]="t.status.name">&nbsp;</div>
                                    <div class="float-left">
                                        <div class="tooltipcell">{{t.taskStatusTimestamp | date: 'MM/dd/yy'}}
                                            <span class="tooltiptext"
                                                [innerHTML]="getTootltipText(t.taskStatusTimestamp, t.status.name)"></span>
                                        </div>
                                    </div>
                                    <div style="clear:both"></div>
                                </div>
                            </td>
                            <td>
                                {{t.name}}
                                <span style="font-size: 12px; font-weight: bold;"
                                    *ngIf="t?.document?.name && t.status.name!= 'Rejected' && !(lgvUserSvc.IsPreLicensedAgent$ | async)"><br>
                                    <a (click)="openTaskDocument(t)">{{t?.document?.name ?? ""}}</a></span>
                                <span style="font-size: 12px; font-weight: bold; color: #FF3A1F;"
                                    *ngIf="t.status.name== 'Rejected' && !(lgvUserSvc.IsPreLicensedAgent$ | async)"><br>{{t?.rejectionReason?.name
                                    ?? ""}}</span>
                            </td>
                            <td style="min-width:75px;">{{t.type.name}}</td>
                            <td><span *ngIf="t.status.name== 'Rejected'"
                                    style="color: #FF3A1F;">{{t?.rejectionReasonNote ?? ""}}
                                </span>{{t.description}}</td>
                            <td *ngIf="isInternalUser">
                                <div style="position:relative;">
                                    <div class="grid-context-menu">
                                        <div class="grid-context-menu-link" [matMenuTriggerFor]="taskMenu"
                                            [title]="getTooltip(t)"
                                            *ngIf="isUploadAllowed(t) || isEditAllowed(t) || isOpenAllowed(t) || isDeleteAllowed(t)"
                                            style="cursor: pointer;">
                                            <fa-icon style="color: #A7A7A7" class="ellipsis" icon="bars"></fa-icon>
                                        </div>
                                        <mat-menu #taskMenu="matMenu">
                                            <div class="rowContextPopupMenu"
                                                [ngClass]="{'disabled': (lgvUserSvc.IsPreLicensedAgent$ |async)}">
                                                <button mat-menu-item title="Open" (click)="onOpenTaskItem(t)"
                                                    *ngIf="isOpenAllowed(t)">
                                                    <span>
                                                        <fa-icon icon="file-lines"></fa-icon>
                                                        Open
                                                    </span>
                                                    <fa-icon *ngIf="(lgvUserSvc.IsPreLicensedAgent$ | async)"
                                                        [icon]="['far', 'lock-keyhole']"></fa-icon>
                                                </button>
                                                <button mat-menu-item title="Upload" (click)="onUploadDocument(t)"
                                                    *ngIf="isUploadAllowed(t)">
                                                    <span>
                                                        <fa-icon icon="file-arrow-up"></fa-icon>
                                                        Upload
                                                    </span>
                                                    <fa-icon *ngIf="(lgvUserSvc.IsPreLicensedAgent$ | async)"
                                                        [icon]="['far', 'lock-keyhole']"></fa-icon>
                                                </button>
                                                <button mat-menu-item title="Upload" (click)="onDuplicateTask(t)"
                                                    *ngIf="isDuplicateAllowed(t)">
                                                    <span>
                                                        <fa-icon icon="file-arrow-up"></fa-icon>
                                                        Duplicate
                                                    </span>
                                                    <fa-icon *ngIf="(lgvUserSvc.IsPreLicensedAgent$ | async)"
                                                        [icon]="['far', 'lock-keyhole']"></fa-icon>
                                                </button>
                                                <button mat-menu-item title="Edit" (click)="onEditTask(t)"
                                                    *ngIf="isEditAllowed(t)">
                                                    <span>
                                                        <fa-icon icon="edit"></fa-icon>
                                                        {{taskIsPendingCreditReport(t) ? 'Start' : 'Edit' }}
                                                    </span>
                                                    <fa-icon *ngIf="(lgvUserSvc.IsPreLicensedAgent$ | async)"
                                                        [icon]="['far', 'lock-keyhole']"></fa-icon>
                                                </button>
                                                <button mat-menu-item title="Delete" (click)="onConfirmDeleteTask(t)"
                                                    *ngIf="isDeleteAllowed(t)">
                                                    <span>
                                                        <fa-icon icon="trash"></fa-icon>
                                                        Delete
                                                    </span>
                                                    <fa-icon *ngIf="(lgvUserSvc.IsPreLicensedAgent$ | async)"
                                                        [icon]="['far', 'lock-keyhole']"></fa-icon>
                                                </button>
                                            </div>
                                        </mat-menu>
                                    </div>
                                </div>
                            </td>
                        </tr>


                    </ng-container>
                </tbody>
            </table>
        </ng-container>

        <div class="Vert-30"></div>
        <lgv-file-upload-box [isInternalUser]="!(lgvUserSvc.IsPreLicensedAgent$ | async)" [uploadBoxCSS]="uploadBoxCSS"
            [showInternalUserCheck]="true" [customText]="'Drag and drop, choose file, or upload photo'"
            (dragOver)="onDragOver($event)" (dropSuccess)="onDropSuccess($event)" (dragLeave)="onDragLeave($event)"
            (clickEvent)="onClickEvent($event)"></lgv-file-upload-box>

    </div>

</div>